<div class="auth">
    <div class="auth__inner" *ngLet="(authenticationStep$ | async) as 'step'">
        <shared-auth-back (onClick)="handleBackClick($event)" class="auth__back"
            *ngIf="(authenticationStep$ | async) !== null"></shared-auth-back>
        <shared-loader-for-spinner *ngIf="!(loyaltyAppDataReady$ | async) && (authenticationStep$ | async) === null"></shared-loader-for-spinner>

        <!-- some kind of rotator / switch case -->
        <shared-auth-for-member-card *ngIf="(authenticationStep$ | async) == 13" [modalData]="modalData">
        </shared-auth-for-member-card>

        <shared-auth-for-cell-sign-in *ngIf="(authenticationStep$ | async) == 0"
            [modalData]="modalData">
        </shared-auth-for-cell-sign-in>

        <shared-auth-for-sign-in-password
            *ngIf="(authenticationStep$ | async) == 1 || (authenticationStep$ | async) == 8" [modalData]="modalData">
        </shared-auth-for-sign-in-password>

        <shared-auth-for-forgot-password *ngIf="(authenticationStep$ | async) == 2" [modalData]="modalData">
        </shared-auth-for-forgot-password>
        <shared-auth-for-forgot-password-sent *ngIf="(authenticationStep$ | async) == 3">
        </shared-auth-for-forgot-password-sent>

        <shared-auth-for-sign-up *ngIf="(authenticationStep$ | async) == 4" [modalData]="modalData">
        </shared-auth-for-sign-up>

        <shared-auth-for-cell-verify *ngIf="(authenticationStep$ | async) == 5" [modalData]="modalData">
        </shared-auth-for-cell-verify>
        <shared-auth-for-cell-verify *ngIf="(authenticationStep$ | async) == 12" [modalData]="modalData">
        </shared-auth-for-cell-verify>

        <shared-auth-for-email-verify *ngIf="(authenticationStep$ | async) == 6" [modalData]="modalData">
        </shared-auth-for-email-verify>

        <shared-auth-for-partial-member-password [memberId]="memberId" *ngIf="(authenticationStep$ | async) == 11"
            [modalData]="modalData">
        </shared-auth-for-partial-member-password>

        <shared-auth-for-confirmation label="Profile Created" *ngIf="(authenticationStep$ | async) == 7"
            [modalData]="modalData">
        </shared-auth-for-confirmation>

        <shared-auth-for-confirmation label="Profile Updated" *ngIf="(authenticationStep$ | async) == 10"
            [modalData]="modalData">
        </shared-auth-for-confirmation>

        <shared-auth-for-unique-code-error *ngIf="(authenticationStep$ | async) == 15" [modalData]="modalData">
        </shared-auth-for-unique-code-error>

        <shared-auth-for-birthday-rewards *ngIf="(authenticationStep$ | async) == 14" [modalData]="modalData">
        </shared-auth-for-birthday-rewards>

        <shared-auth-for-rewards-account-linking-info *ngIf="(authenticationStep$ | async) == 16"
            [modalData]="modalData">
        </shared-auth-for-rewards-account-linking-info>

        <shared-auth-for-rewards-account-linking-sign-up *ngIf="(authenticationStep$ | async) == 17"
            [modalData]="modalData">
        </shared-auth-for-rewards-account-linking-sign-up>

        <shared-auth-for-rewards-account-linking-password *ngIf="(authenticationStep$ | async) == 18"
            [modalData]="modalData">
        </shared-auth-for-rewards-account-linking-password>
    </div>
</div>